const { suppliedLocationContent } = require("./suppliedLocationContentV2");

const locationPageContent = {
  "new-perungalathur": {
    heroIntro:
      "Revive Family Clinic & X-Ray Diagnostics provides a convenient healthcare option for families in New Perungalathur, with consultations and diagnostic support available from the clinic's verified location.",
    sectionTitle: "Family Healthcare Near New Perungalathur",
    overview: [
      "If you are searching for a family clinic in New Perungalathur, Revive offers a clear starting point for everyday health concerns, preventive guidance and ongoing care conversations.",
      "The clinic is at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Patients can contact the team before travelling to ask about the consultation or diagnostic service they need.",
    ],
    serviceHeading: "Medical and Diagnostic Support",
    serviceText:
      "Depending on the patient's needs, the clinic can be contacted about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Visit the services page for an overview, then contact the clinic to confirm availability and appointment arrangements.",
    visitHeading: "Plan Your New Perungalathur Clinic Visit",
    visitText:
      "Call or WhatsApp the clinic before visiting if you need help with timing, directions or service availability. The verified address, phone number and opening hours are shown in the visit details below.",
    faqs: [
      {
        question: "Can New Perungalathur residents contact Revive for family healthcare?",
        answer:
          "Yes. Revive Family Clinic is located in New Perungalathur and can be contacted about family medicine, preventive guidance and other available consultations.",
      },
      {
        question: "Where is Revive Family Clinic in New Perungalathur?",
        answer:
          "The verified address is MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "How can I confirm a service before travelling from New Perungalathur?",
        answer:
          "Call or WhatsApp Revive Family Clinic using the contact details on the website to confirm service availability and appointment arrangements.",
      },
    ],
  },
  "perungalathur": {
    heroIntro:
      "People in Perungalathur can contact Revive Family Clinic & X-Ray Diagnostics in nearby New Perungalathur for family healthcare, orthopaedic consultation and digital diagnostic support.",
    sectionTitle: "A Clinic Option for Perungalathur Families",
    overview: [
      "Choosing a clinic near Perungalathur can make it easier to organise a consultation around family routines. Revive provides a local point of contact for patients who want to ask about general healthcare and diagnostic needs.",
      "The clinic's verified location is in New Perungalathur at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam. Contact the team for current availability before planning a visit.",
    ],
    serviceHeading: "Care and Diagnostics to Enquire About",
    serviceText:
      "Patients from Perungalathur can enquire about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. The services page explains the available categories without replacing a consultation with a healthcare professional.",
    visitHeading: "Arrange a Visit from Perungalathur",
    visitText:
      "Use the contact page to request an appointment or ask about opening hours. Calling or WhatsApping first helps the clinic confirm the right next step for your enquiry.",
    faqs: [
      {
        question: "Is Revive Family Clinic available to patients from Perungalathur?",
        answer:
          "Yes. Patients from Perungalathur can contact the clinic in nearby New Perungalathur to enquire about consultations and available diagnostic support.",
      },
      {
        question: "What should Perungalathur patients confirm before visiting?",
        answer:
          "Please confirm the service you need, consultation timing and appointment arrangement with the clinic before travelling.",
      },
      {
        question: "Where can I find the verified Perungalathur-area clinic details?",
        answer:
          "The website contact page lists the clinic's verified phone number, email, address and opening hours for patients planning a visit.",
      },
    ],
  },
  "peerkankaranai": {
    heroIntro:
      "Revive Family Clinic & X-Ray Diagnostics is a nearby healthcare option for people in Peerkankaranai who need to enquire about family consultations, ongoing care or digital diagnostics.",
    sectionTitle: "Family Clinic Support for Peerkankaranai",
    overview: [
      "For Peerkankaranai families, a nearby clinic can simplify the first step of arranging healthcare. Revive welcomes enquiries about everyday family health needs and the diagnostic services listed on its website.",
      "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the clinic directly to check whether the required consultation or diagnostic service is available.",
    ],
    serviceHeading: "Services for Your Enquiry",
    serviceText:
      "Peerkankaranai patients can read about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. The clinic team can explain which appointment route is appropriate for the patient's request.",
    visitHeading: "Contact Before Your Peerkankaranai Visit",
    visitText:
      "Use the appointment link or the verified phone and WhatsApp details to ask about timing, directions and availability. This keeps the information current before you travel.",
    faqs: [
      {
        question: "Can I enquire about family care from Peerkankaranai?",
        answer:
          "Yes. Peerkankaranai residents can contact Revive Family Clinic in New Perungalathur about family healthcare and the services listed on the website.",
      },
      {
        question: "Does the Peerkankaranai page confirm a specific diagnosis?",
        answer:
          "No. It provides general clinic information only. A healthcare professional must discuss an individual's symptoms and appropriate care.",
      },
      {
        question: "How do Peerkankaranai patients check appointment availability?",
        answer:
          "Call or WhatsApp the clinic before travelling to confirm appointment arrangements and the availability of the service required.",
      },
    ],
  },
  "tambaram": {
    heroIntro:
      "Families in Tambaram can contact Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare, orthopaedic consultation and digital X-ray enquiries.",
    sectionTitle: "Family Healthcare for Tambaram Patients",
    overview: [
      "When you are looking for a family clinic near Tambaram, Revive provides a verified clinic contact for consultations, preventive guidance and diagnostic enquiries.",
      "The clinic is based at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Patients should contact the clinic to confirm timing and availability before visiting from Tambaram.",
    ],
    serviceHeading: "What Tambaram Patients Can Enquire About",
    serviceText:
      "The clinic website describes family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Use the services page to understand the categories and the contact page to plan an appointment.",
    visitHeading: "Plan Your Tambaram Enquiry",
    visitText:
      "For directions, opening hours or a service question, call or WhatsApp the clinic. The team can confirm the practical details for your visit.",
    faqs: [
      {
        question: "Can Tambaram families contact Revive Family Clinic?",
        answer:
          "Yes. Tambaram patients can contact Revive's New Perungalathur clinic to enquire about family healthcare, consultations and listed diagnostic services.",
      },
      {
        question: "Is the Tambaram page a substitute for medical advice?",
        answer:
          "No. The page is for clinic information. Please discuss symptoms, diagnosis and treatment with a qualified healthcare professional.",
      },
      {
        question: "How can I arrange a Tambaram-area appointment?",
        answer:
          "Use the website contact page or call or WhatsApp the clinic to ask about available times and the service you need.",
      },
    ],
  },
  "west-tambaram": {
    heroIntro:
      "Revive Family Clinic & X-Ray Diagnostics gives West Tambaram residents a verified way to enquire about family consultations, orthopaedic care and digital diagnostic support in New Perungalathur.",
    sectionTitle: "Healthcare Enquiries from West Tambaram",
    overview: [
      "West Tambaram patients can use Revive as a nearby clinic contact for everyday family health questions, preventive guidance and enquiries about diagnostic services.",
      "The clinic's confirmed address is MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Please contact the team before making the journey so the current appointment details are clear.",
    ],
    serviceHeading: "Family Care and Diagnostic Information",
    serviceText:
      "Revive's listed services include family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Patients can follow the internal services link for an overview and contact the clinic for confirmation.",
    visitHeading: "A Practical Next Step for West Tambaram",
    visitText:
      "If you need directions, opening hours or an appointment request, use the contact page or the verified phone and WhatsApp details shown below.",
    faqs: [
      {
        question: "What can West Tambaram patients ask Revive about?",
        answer:
          "They can ask about family medicine, diabetes care, preventive guidance, orthopaedic consultation and digital X-ray diagnostics listed by the clinic.",
      },
      {
        question: "Where is the clinic serving West Tambaram enquiries?",
        answer:
          "Revive Family Clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "Should I contact Revive before travelling from West Tambaram?",
        answer:
          "Yes. Calling or WhatsApping first lets the clinic confirm availability, timing and appointment arrangements for your request.",
      },
    ],
  },
  "east-tambaram": {
    heroIntro:
      "Residents of East Tambaram can reach out to Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare and diagnostic information.",
    sectionTitle: "Family Clinic Information for East Tambaram",
    overview: [
      "A nearby clinic contact can help East Tambaram families plan routine consultations and ask informed questions about available services. Revive provides that information through its website and contact team.",
      "The verified clinic address is in New Perungalathur at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam. Please confirm the service and timing before visiting.",
    ],
    serviceHeading: "Enquire About the Right Clinic Service",
    serviceText:
      "East Tambaram patients can enquire about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. The clinic's services page and contact page provide the next steps.",
    visitHeading: "Organise Your East Tambaram Visit",
    visitText:
      "For a service question or appointment request, call or WhatsApp the clinic using the verified details below. The team can help confirm practical visit information.",
    faqs: [
      {
        question: "Does Revive accept enquiries from East Tambaram?",
        answer:
          "Yes. East Tambaram residents can contact the New Perungalathur clinic about consultations and the medical and diagnostic services listed online.",
      },
      {
        question: "What location should East Tambaram patients use for directions?",
        answer:
          "Use the verified address on this page: MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "How can I ask about an appointment from East Tambaram?",
        answer:
          "Use the contact page or call or WhatsApp Revive before travelling to ask about the service and available appointment arrangements.",
      },
    ],
  },
  "vandalur": {
    heroIntro:
      "Vandalur residents can contact Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare, diabetes-care enquiries, orthopaedic consultation and digital imaging information.",
    sectionTitle: "Healthcare Support for Vandalur Families",
    overview: [
      "For people in Vandalur, Revive provides a verified clinic option to consider when arranging a family consultation or asking about diagnostic support.",
      "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the clinic directly to confirm current availability and opening hours before travelling.",
    ],
    serviceHeading: "Services Vandalur Patients Can Discuss",
    serviceText:
      "The clinic lists family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. These pages explain the service categories; the clinic team can confirm what is available for a particular appointment.",
    visitHeading: "Check Details Before Leaving Vandalur",
    visitText:
      "Use the contact page to request an appointment, or call or WhatsApp the clinic for directions and timing questions.",
    faqs: [
      {
        question: "Can Vandalur residents enquire about Revive's services?",
        answer:
          "Yes. Vandalur residents can contact Revive Family Clinic in New Perungalathur about the family healthcare and diagnostic services listed on the website.",
      },
      {
        question: "What should I confirm before a Vandalur visit?",
        answer:
          "Confirm the service, consultation timing and appointment arrangement with the clinic before travelling.",
      },
      {
        question: "Where can Vandalur patients find verified contact details?",
        answer:
          "The contact page provides the clinic's verified phone number, email, address and opening hours.",
      },
    ],
  },
  "mannivakkam": {
    heroIntro:
      "Revive Family Clinic & X-Ray Diagnostics is a clinic contact for Mannivakkam residents seeking information about family consultations, preventive care and digital diagnostics.",
    sectionTitle: "A Family Clinic Option Near Mannivakkam",
    overview: [
      "Mannivakkam families can use this page to understand how to enquire with Revive before arranging a visit. The clinic focuses on clear communication about available healthcare and diagnostic services.",
      "Revive is located in New Perungalathur at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam. Please use the verified contact details to confirm the right appointment route.",
    ],
    serviceHeading: "Discuss Your Healthcare Requirement",
    serviceText:
      "Mannivakkam patients can enquire about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Internal links to services and contact information make it easier to plan the next step.",
    visitHeading: "Contact Revive from Mannivakkam",
    visitText:
      "Call or WhatsApp the clinic if you need to check availability, opening hours or directions. Request an appointment through the contact page when you are ready.",
    faqs: [
      {
        question: "What healthcare information can Mannivakkam patients request?",
        answer:
          "They can ask about family medicine, diabetes care, preventive guidance, orthopaedic consultation and digital X-ray diagnostics available through Revive.",
      },
      {
        question: "Is Revive's verified clinic address in Mannivakkam?",
        answer:
          "The clinic is located in New Perungalathur at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "How can Mannivakkam patients plan a consultation?",
        answer:
          "Use the contact page or call or WhatsApp the clinic to confirm the service and arrange an appropriate appointment.",
      },
    ],
  },
  "mudichur": {
    heroIntro:
      "Families in Mudichur can enquire with Revive Family Clinic & X-Ray Diagnostics in New Perungalathur about family healthcare, orthopaedic consultation and digital X-ray services.",
    sectionTitle: "Family Healthcare Enquiries from Mudichur",
    overview: [
      "If you are comparing clinic options near Mudichur, Revive provides verified information about its consultations, diagnostic support, location and contact process.",
      "The clinic is at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the team to confirm availability before scheduling your visit.",
    ],
    serviceHeading: "Services to Ask About",
    serviceText:
      "Mudichur patients can read about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. The clinic will confirm the appropriate service and appointment details for each enquiry.",
    visitHeading: "Plan Your Route from Mudichur",
    visitText:
      "For current timing, directions or an appointment request, use the contact page or call or WhatsApp the clinic using the details below.",
    faqs: [
      {
        question: "Can Mudichur families contact Revive Family Clinic?",
        answer:
          "Yes. Mudichur residents can contact the New Perungalathur clinic to enquire about family healthcare and the listed diagnostic services.",
      },
      {
        question: "Does the Mudichur page provide individual medical advice?",
        answer:
          "No. It provides general clinic information. A qualified healthcare professional should assess each patient's individual concern.",
      },
      {
        question: "How do I confirm availability before travelling from Mudichur?",
        answer:
          "Call or WhatsApp Revive Family Clinic before travelling to confirm the service, timing and appointment arrangement.",
      },
    ],
  },
  "urapakkam": {
    heroIntro:
      "Urapakkam residents can use Revive Family Clinic & X-Ray Diagnostics in New Perungalathur as a verified contact for family healthcare and digital diagnostic enquiries.",
    sectionTitle: "Clinic Information for Urapakkam Patients",
    overview: [
      "Revive helps patients from Urapakkam take the next practical step when they need to ask about a family consultation, preventive guidance or diagnostic service.",
      "The clinic's verified address is MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Please confirm details with the clinic before visiting.",
    ],
    serviceHeading: "Family Care, Ongoing Support and Imaging",
    serviceText:
      "Urapakkam patients can enquire about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Follow the services link for an overview and the contact link for appointment planning.",
    visitHeading: "Start with a Verified Contact",
    visitText:
      "Call or WhatsApp the clinic to ask about opening hours, directions and current service availability. You can also request an appointment through the contact page.",
    faqs: [
      {
        question: "What can Urapakkam patients enquire about at Revive?",
        answer:
          "They can enquire about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics.",
      },
      {
        question: "Where is Revive located for Urapakkam patients?",
        answer:
          "Revive Family Clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "Can Urapakkam patients request an appointment online?",
        answer:
          "Yes. Use the website contact page to request an appointment, then confirm the timing and service with the clinic.",
      },
    ],
  },
  "kilambakkam": {
    heroIntro:
      "People in Kilambakkam can contact Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare, orthopaedic consultation and digital X-ray information.",
    sectionTitle: "A Nearby Clinic Contact for Kilambakkam",
    overview: [
      "For Kilambakkam families, Revive offers a verified clinic contact when they need to ask about general healthcare, ongoing diabetes support or diagnostic arrangements.",
      "The clinic is at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Patients should contact the team to confirm availability before travelling.",
    ],
    serviceHeading: "Understand the Available Service Categories",
    serviceText:
      "The website describes family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Read the service information and then contact Revive about the appointment that fits your enquiry.",
    visitHeading: "Arrange Your Kilambakkam Enquiry",
    visitText:
      "The verified phone, WhatsApp and contact-page details can be used to ask about timings, directions and the next available appointment.",
    faqs: [
      {
        question: "Does Revive accept enquiries from Kilambakkam?",
        answer:
          "Yes. Kilambakkam residents can contact the clinic in New Perungalathur about the family healthcare and diagnostic services listed online.",
      },
      {
        question: "What information should I have ready when I call from Kilambakkam?",
        answer:
          "Tell the clinic which service you are asking about and ask them to confirm timing, availability and appointment requirements.",
      },
      {
        question: "Where can Kilambakkam patients find the clinic address?",
        answer:
          "The verified address and directions link are available on the website contact page and in the visit details on this page.",
      },
    ],
  },
  "guduvanchery": {
    heroIntro:
      "Guduvanchery families can enquire with Revive Family Clinic & X-Ray Diagnostics in New Perungalathur about consultations, preventive care and digital diagnostic support.",
    sectionTitle: "Healthcare Information for Guduvanchery",
    overview: [
      "When a patient in Guduvanchery needs a clinic contact, Revive provides verified information about its family healthcare and diagnostic services without making assumptions about an individual's condition.",
      "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the clinic directly to check the latest availability.",
    ],
    serviceHeading: "Services for Guduvanchery Enquiries",
    serviceText:
      "Guduvanchery patients can ask about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. The services page and contact page provide clear internal routes for further information.",
    visitHeading: "Confirm Your Visit Details",
    visitText:
      "Before travelling from Guduvanchery, call or WhatsApp the clinic to confirm hours, directions and the service you need. Appointment requests can be made through the contact page.",
    faqs: [
      {
        question: "Can Guduvanchery patients enquire about Revive's family clinic services?",
        answer:
          "Yes. Guduvanchery residents can contact Revive in New Perungalathur about family consultations, preventive guidance and listed diagnostics.",
      },
      {
        question: "Are digital X-ray services confirmed for every Guduvanchery enquiry?",
        answer:
          "The clinic lists digital X-ray diagnostics, but patients should contact Revive to confirm availability and appointment requirements for their specific request.",
      },
      {
        question: "How do I plan a Guduvanchery-area appointment?",
        answer:
          "Use the contact page or call or WhatsApp the clinic to discuss your enquiry and confirm a suitable appointment arrangement.",
      },
    ],
  },
  "irumbuliyur": {
    heroIntro:
      "Revive Family Clinic & X-Ray Diagnostics provides Irumbuliyur residents with a verified way to enquire about family medicine, orthopaedic consultation and digital diagnostics.",
    sectionTitle: "Family Clinic Enquiries from Irumbuliyur",
    overview: [
      "People in Irumbuliyur can use this page to find practical information before contacting Revive. The clinic can answer questions about consultations, preventive care and the diagnostic services it lists.",
      "Revive is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Please contact the clinic to confirm timing and availability before a visit.",
    ],
    serviceHeading: "Discuss Family Health and Diagnostics",
    serviceText:
      "The clinic's verified service categories include family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Patients can read the services page and then request the appropriate appointment.",
    visitHeading: "Use the Verified Contact Details",
    visitText:
      "Call or WhatsApp Revive for opening hours, directions and service questions. The contact page can be used to request an appointment from Irumbuliyur.",
    faqs: [
      {
        question: "What can Irumbuliyur residents ask Revive about?",
        answer:
          "They can ask about family medicine, diabetes care, preventive guidance, orthopaedic consultation and digital X-ray diagnostics listed by the clinic.",
      },
      {
        question: "Is the clinic address verified for Irumbuliyur visitors?",
        answer:
          "Yes. The verified address is MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "Should I confirm an appointment before leaving Irumbuliyur?",
        answer:
          "Yes. Contact the clinic first to confirm the service, timing and appointment arrangements for your visit.",
      },
    ],
  },
  "chromepet": {
    heroIntro:
      "Chromepet patients can contact Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare, orthopaedic consultation and digital X-ray enquiries.",
    sectionTitle: "A Clinic Option for Chromepet Families",
    overview: [
      "For people looking for a family clinic near Chromepet, Revive provides a verified source of information about consultations, preventive guidance and diagnostic support.",
      "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the team to confirm availability before planning a visit.",
    ],
    serviceHeading: "What Chromepet Patients Can Enquire About",
    serviceText:
      "Revive lists family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Patients can explore the services page and use the contact page to ask about their specific requirement.",
    visitHeading: "Plan Your Chromepet Visit",
    visitText:
      "Call or WhatsApp the clinic for current opening hours, directions and appointment information. This helps keep your travel plan aligned with service availability.",
    faqs: [
      {
        question: "Can Chromepet residents book a Revive consultation?",
        answer:
          "Chromepet residents can contact Revive Family Clinic in New Perungalathur to enquire about available consultations and appointment arrangements.",
      },
      {
        question: "What services are listed for Chromepet patients?",
        answer:
          "The clinic lists family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics.",
      },
      {
        question: "Where can I confirm directions from Chromepet?",
        answer:
          "Use the verified address and Google Maps link on the contact page, and call or WhatsApp the clinic if you need help before travelling.",
      },
    ],
  },
  "pallavaram": {
    heroIntro:
      "Are you looking for a family clinic near Pallavaram, Chennai? Revive Family Clinic & X-Ray Diagnostics welcomes enquiries from individuals and families in Pallavaram who are looking for information about healthcare services and medical consultations.",
    h1: "Family Clinic Near Pallavaram, Chennai",
    customSections: [
      {
        heading: "Family Healthcare Support for Pallavaram Residents",
        paragraphs: [
          "Choosing a healthcare provider for yourself and your family is an important decision. Patients may look for a convenient clinic where they can enquire about general healthcare, preventive care, and medical consultations.",
          "Revive Family Clinic & X-Ray Diagnostics offers healthcare services from its Nedunkundram location. Patients from Pallavaram can contact our team to confirm the services currently available and get information before planning a visit.",
        ],
      },
      {
        heading: "Healthcare Services at Revive Family Clinic",
        paragraphs: ["The clinic’s listed healthcare services include:"],
        list: [
          "Family Medicine",
          "General Consultation",
          "Preventive Healthcare",
          "Women’s Healthcare",
          "Children’s Healthcare",
          "Elderly Care",
          "Health Check-ups",
          "Diabetes Diagnostics",
        ],
        includeServiceLinks: true,
      },
      {
        heading: "Looking for a Medical Clinic Near Pallavaram?",
        paragraphs: [
          "If you are searching online for a family clinic near Pallavaram, it is important to check the clinic’s actual location, services, and consultation availability.",
          "Revive Family Clinic & X-Ray Diagnostics is located in Nedunkundram and welcomes enquiries from patients in Pallavaram and surrounding localities.",
          "Contact our team to learn more about the available healthcare services and whether an appointment is required.",
        ],
      },
      {
        heading: "Revive Family Clinic & X-Ray Diagnostics – Clinic Location",
        paragraphs: [
          "Our clinic is located at:",
          "MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu – 600063.",
          "Patients travelling from Pallavaram are encouraged to contact the clinic before visiting to confirm consultation timings and service availability.",
        ],
      },
      {
        heading: "Contact Revive Family Clinic",
        paragraphs: [
          "For information about healthcare services, consultations, or appointments, please use the contact details available on the Revive Family Clinic & X-Ray Diagnostics website.",
          "We welcome enquiries from Pallavaram and nearby areas.",
        ],
        includeAreaLinks: true,
      },
    ],
    faqs: [
      {
        question: "Is Revive Family Clinic located in Pallavaram?",
        answer:
          "Revive Family Clinic & X-Ray Diagnostics is located in Nedunkundram, Tamil Nadu. Patients from Pallavaram can contact the clinic to enquire about available healthcare services.",
      },
      {
        question: "Is there a family clinic near Pallavaram?",
        answer:
          "Patients searching for a family clinic near Pallavaram can contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to learn about its healthcare services.",
      },
      {
        question: "What healthcare services are available at Revive Family Clinic?",
        answer:
          "The clinic’s listed services include Family Medicine, General Consultation, Preventive Healthcare, Women’s Healthcare, Children’s Healthcare, Elderly Care, Health Check-ups, and Diabetes Diagnostics. Please confirm current availability directly with the clinic.",
      },
      {
        question: "Where is Revive Family Clinic located?",
        answer:
          "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu – 600063.",
      },
      {
        question: "How can Pallavaram patients enquire about an appointment?",
        answer:
          "Use the website contact details or call the clinic to confirm consultation timings, service availability and appointment requirements before visiting.",
      },
    ],
  },
  "selaiyur": {
    heroIntro:
      "Selaiyur residents can contact Revive Family Clinic & X-Ray Diagnostics in New Perungalathur for family healthcare, preventive guidance and diagnostic enquiries.",
    sectionTitle: "A Family Clinic Contact for Selaiyur",
    overview: [
      "When patients in Selaiyur are looking for a nearby family clinic, Revive provides verified information about its location, services and appointment process.",
      "The clinic is at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Contact the clinic first to confirm the latest details before visiting.",
    ],
    serviceHeading: "Services Selaiyur Patients Can Discuss",
    serviceText:
      "The clinic's listed categories include family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Use the services page for context and contact Revive for a patient-specific enquiry.",
    visitHeading: "Make a Well-Informed Selaiyur Visit",
    visitText:
      "Call or WhatsApp the clinic about timing, directions and availability. You can also request an appointment through the contact page.",
    faqs: [
      {
        question: "Can Selaiyur patients contact Revive about family healthcare?",
        answer:
          "Yes. Selaiyur residents can contact Revive's New Perungalathur clinic about consultations and the listed medical and diagnostic services.",
      },
      {
        question: "What is the verified clinic location for Selaiyur visitors?",
        answer:
          "The clinic is at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063.",
      },
      {
        question: "How can I check appointment timing from Selaiyur?",
        answer:
          "Use the verified phone or WhatsApp details to confirm timing and service availability before travelling.",
      },
    ],
  },
  "padappai": {
    heroIntro:
      "Padappai families can enquire with Revive Family Clinic & X-Ray Diagnostics in New Perungalathur about family consultations, orthopaedic care and digital diagnostic support.",
    sectionTitle: "Healthcare Enquiries for Padappai",
    overview: [
      "Revive offers Padappai residents a verified clinic contact for questions about everyday family healthcare, preventive guidance and the diagnostic services shown on the website.",
      "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur. Please confirm the required service and timing before travelling.",
    ],
    serviceHeading: "Explore Services, Then Contact the Clinic",
    serviceText:
      "Patients from Padappai can read about family medicine, diabetes care, preventive health guidance, orthopaedic consultation and digital X-ray diagnostics. Revive can confirm the appropriate appointment route for each enquiry.",
    visitHeading: "Arrange Your Padappai Visit",
    visitText:
      "Use the contact page to request an appointment, or call or WhatsApp the clinic to confirm current availability, opening hours and directions.",
    faqs: [
      {
        question: "Can Padappai residents enquire about Revive's services?",
        answer:
          "Yes. Padappai residents can contact Revive Family Clinic in New Perungalathur about family healthcare, orthopaedic consultation and listed diagnostics.",
      },
      {
        question: "What should I confirm before travelling from Padappai?",
        answer:
          "Confirm the service, opening hours and appointment requirements with Revive before travelling.",
      },
      {
        question: "Where are the verified contact details for Padappai patients?",
        answer:
          "The website contact page and the visit details on this page show the verified phone, email, address and opening hours.",
      },
    ],
  },
};

const createAreaSeoContent = (area) => ({
  heroIntro:
    `Are you looking for a family clinic near ${area}, Chennai? Revive Family Clinic & X-Ray Diagnostics welcomes enquiries from individuals and families in ${area} who are looking for information about healthcare services and medical consultations.`,
  h1: `Family Clinic Near ${area}, Chennai`,
  serviceHeading: "Healthcare Services at Revive Family Clinic",
  serviceText:
    "The clinic’s listed healthcare services include Family Medicine, General Consultation, Preventive Healthcare, Women’s Healthcare, Children’s Healthcare, Elderly Care, Health Check-ups, and Diabetes Diagnostics. Please contact the clinic to confirm availability and details before visiting.",
  visitHeading: "Contact Revive Family Clinic",
  visitText: `Patients travelling from ${area} are encouraged to contact the clinic before visiting to confirm consultation timings and service availability.`,
  customSections: [
    {
      heading: `Family Clinic Near ${area}, Chennai`,
      paragraphs: [
        `Are you looking for a family clinic near ${area}, Chennai? Revive Family Clinic & X-Ray Diagnostics welcomes enquiries from individuals and families in ${area} who are looking for information about healthcare services and medical consultations.`,
        `Located in Nedunkundram, Revive Family Clinic provides healthcare services for patients from nearby areas. Residents of ${area} can contact our clinic to enquire about available services, consultation details, and appointment availability.`,
        "Our goal is to help patients access relevant healthcare information and understand the services available at our clinic.",
      ],
    },
    {
      heading: `Family Healthcare Support for ${area} Residents`,
      paragraphs: [
        "Choosing a healthcare provider for yourself and your family is an important decision. Patients may look for a convenient clinic where they can enquire about general healthcare, preventive care, and medical consultations.",
        `Revive Family Clinic & X-Ray Diagnostics offers healthcare services from its Nedunkundram location. Patients from ${area} can contact our team to confirm the services currently available and get information before planning a visit.`,
      ],
    },
    {
      heading: "Healthcare Services at Revive Family Clinic",
      paragraphs: ["The clinic’s listed healthcare services include:"],
      list: [
        "Family Medicine",
        "General Consultation",
        "Preventive Healthcare",
        "Women’s Healthcare",
        "Children’s Healthcare",
        "Elderly Care",
        "Health Check-ups",
        "Diabetes Diagnostics",
      ],
      includeServiceLinks: true,
    },
    {
      heading: `Looking for a Medical Clinic Near ${area}?`,
      paragraphs: [
        `If you are searching online for a family clinic near ${area}, it is important to check the clinic’s actual location, services, and consultation availability.`,
        `Revive Family Clinic & X-Ray Diagnostics is located in Nedunkundram and welcomes enquiries from patients in ${area} and surrounding localities.`,
        "Contact our team to learn more about the available healthcare services and whether an appointment is required.",
      ],
    },
    {
      heading: "Revive Family Clinic & X-Ray Diagnostics – Clinic Location",
      paragraphs: [
        "Our clinic is located at:",
        "MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu – 600063.",
        `Patients travelling from ${area} are encouraged to contact the clinic before visiting to confirm consultation timings and service availability.`,
      ],
    },
    {
      heading: "Contact Revive Family Clinic",
      paragraphs: [
        "For information about healthcare services, consultations, or appointments, please use the contact details available on the Revive Family Clinic & X-Ray Diagnostics website.",
        `We welcome enquiries from ${area} and nearby areas.`,
      ],
        includeAreaLinks: true,
    },
  ],
  faqs: [
    {
      question: `Is Revive Family Clinic located in ${area}?`,
      answer: `Revive Family Clinic & X-Ray Diagnostics is located in Nedunkundram, Tamil Nadu. Patients from ${area} can contact the clinic to enquire about available healthcare services.`,
    },
    {
      question: `Is there a family clinic near ${area}?`,
      answer: `Patients searching for a family clinic near ${area} can contact Revive Family Clinic & X-Ray Diagnostics in Nedunkundram to learn about its available services and consultation details.`,
    },
    {
      question: "What healthcare services are available at Revive Family Clinic?",
      answer:
        "The clinic’s listed services include Family Medicine, General Consultation, Preventive Healthcare, Women’s Healthcare, Children’s Healthcare, Elderly Care, Health Check-ups, and Diabetes Diagnostics. Please confirm current availability directly with the clinic.",
    },
    {
      question: "Where is Revive Family Clinic located?",
      answer:
        "The clinic is located at MA Complex, NGO Nagar Main Road, SSM Nagar, Alappakam, New Perungalathur, Nedunkundram, Tamil Nadu – 600063.",
    },
    {
      question: "How can I enquire about an appointment?",
      answer:
        "You can contact Revive Family Clinic & X-Ray Diagnostics using the contact details available on the clinic website to confirm appointment availability and consultation timings.",
    },
  ],
});

// The supplied briefs for New Perungalathur and Perungalathur use “in” as the
// search phrase. Start with the same verified service/location facts as the
// nearby-area template, then change only the location wording. This keeps all
// pages consistent without making an unsupported branch or service claim.
const createInAreaSeoContent = (area, clinicIsActuallyHere = false) => {
  const content = createAreaSeoContent(area);
  const replaceText = (value) => {
    if (typeof value !== "string") return value;
    const replace = (text, search, replacement) =>
      text.split(search).join(replacement);
    let next = value;
    next = replace(next, `family clinic near ${area}`, `family clinic in ${area}`);
    next = replace(next, `Family Clinic Near ${area}`, `Family Clinic in ${area}`);
    next = replace(next, `Medical Clinic Near ${area}`, `Medical Clinic in ${area}`);
    next = replace(
      next,
      `Family Healthcare Support for ${area} Residents`,
      `Family Healthcare Support in ${area}`,
    );
    if (clinicIsActuallyHere) {
      next = next
        .replaceAll("Located in Nedunkundram, Revive Family Clinic", `Located in ${area}, Revive Family Clinic`)
        .replaceAll("is located in Nedunkundram and welcomes enquiries", `is located in ${area} and welcomes enquiries`)
        .replaceAll("is located in Nedunkundram, Tamil Nadu", `is located in ${area}, Tamil Nadu`);
    }
    return next;
  };

  return {
    ...content,
    heroIntro: replaceText(content.heroIntro),
    h1: replaceText(content.h1),
    serviceHeading: replaceText(content.serviceHeading),
    serviceText: replaceText(content.serviceText),
    visitHeading: replaceText(content.visitHeading),
    visitText: replaceText(content.visitText),
    customSections: content.customSections.map((section) => ({
      ...section,
      heading: replaceText(section.heading),
      paragraphs: section.paragraphs?.map(replaceText),
      list: section.list,
    })),
    faqs: content.faqs.map((faq) => ({
      question: replaceText(faq.question),
      answer: replaceText(faq.answer),
    })),
  };
};

[
  "guduvanchery",
  "mudichur",
  "east-tambaram",
  "peerkankaranai",
  "vandalur",
  "tambaram",
  "urapakkam",
  "irumbuliyur",
  "selaiyur",
  "padappai",
  "chromepet",
  "kilambakkam",
  "mannivakkam",
  "west-tambaram",
].forEach((slug) => {
  const area = locationPageContent[slug]?.sectionTitle
    ?.replace(/^.*for /, "")
    ?.replace(/^.*Information for /, "")
    ?.replace(/^.*from /, "")
    ?.replace(/^.*Near /, "");
  const names = {
    guduvanchery: "Guduvanchery",
    mudichur: "Mudichur",
    "east-tambaram": "East Tambaram",
    peerkankaranai: "Peerkankaranai",
    vandalur: "Vandalur",
    tambaram: "Tambaram",
    urapakkam: "Urapakkam",
    irumbuliyur: "Irumbuliyur",
    selaiyur: "Selaiyur",
    padappai: "Padappai",
    chromepet: "Chromepet",
    kilambakkam: "Kilambakkam",
    mannivakkam: "Mannivakkam",
    "west-tambaram": "West Tambaram",
  };
  locationPageContent[slug] = {
    ...locationPageContent[slug],
    ...createAreaSeoContent(names[slug] || area),
  };
});

locationPageContent["new-perungalathur"] = {
  ...locationPageContent["new-perungalathur"],
  ...createInAreaSeoContent("New Perungalathur", true),
};

locationPageContent["perungalathur"] = {
  ...locationPageContent["perungalathur"],
  ...createInAreaSeoContent("Perungalathur"),
};

// Replace the shorter fallback copy with the full, approved SEO briefs for
// every service-area route while leaving the Nedunkundram page untouched.
Object.entries(suppliedLocationContent).forEach(([slug, content]) => {
  locationPageContent[slug] = {
    ...locationPageContent[slug],
    ...content,
  };
});

export { locationPageContent };
export default locationPageContent;
